import { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import axios from "axios";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
import CustomTable from "../../components/CustomTable";
import CustomButton from "../../components/CustomButton";
import DeleteModal from '../../components/DeleteModal';
import { ApiUrl } from "../../Constants/Weburl";

// export default function BadWordsPage() {
//     const [badwords, setBadwords] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [showModal, setShowModal] = useState(false);
//     const [editId, setEditId] = useState(null);
//     const [word, setWord] = useState("");
//     const [language, setLanguage] = useState("en");
//     const [action, setAction] = useState("block");

//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [deleteId, setDeleteId] = useState(null);

//     const fetchBadwords = async () => {
//         try {
//             setLoading(true);
//             const res = await axios.get(`${ApiUrl}api/getbadwords`);
//             setBadwords(res.data.data);
//         } catch (err) {
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBadwords();
//     }, []);

//     const handleAdd = () => {
//         setEditId(null);
//         setWord("");
//         setLanguage("en");
//         setAction("block");
//         setShowModal(true);
//     };

//     const handleEdit = (item) => {
//         setEditId(item.id);
//         setWord(item.word);
//         setLanguage(item.language);
//         setAction(item.action);
//         setShowModal(true);
//     };

//     const closeReasonModal = () => {
//         setShowModal(false);
//         setEditId(null);
//     };

//     const handleSubmit = async () => {
//         if (!word.trim()) return;
//         try {
//             if (editId) {
//                 await axios.put(`${ApiUrl}api/updatebadwords/${editId}`, { word, language, action });
//             } else {

//                 await axios.post(`${ApiUrl}api/postbadwords`, { word, language, action });
//             }
//             closeReasonModal();
//             fetchBadwords();
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const handleDeleteClick = (id) => {
//         setDeleteId(id);
//         setShowDeleteModal(true);
//     };

//     const deleteBadword = async () => {
//         try {
//             await axios.delete(`${ApiUrl}api/deletebadwords/${deleteId}`);
//             setShowDeleteModal(false);
//             setDeleteId(null);
//             fetchBadwords();
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const languageLabel = (code) => {
//         const map = { en: "English", ta: "Tamil", te: "Telugu", kn: "Kannada", ml: "Malayalam", hi: "Hindi" };
//         return map[code] || code;
//     };

//     return (
//         <>
//             <Layout>
//                 <SettingsPageShell
//                     title="BAD WORDS FILTER"
//                     headerRight={
//                         <button className="rr-add-btn" onClick={handleAdd}>
//                             Add Bad Word
//                         </button>
//                     }
//                 >
//                     {loading ? (
//                         <div className="rr-card">
//                             <p>Loading...</p>
//                         </div>
//                     ) : (
//                         <div className="rr-card">
//                             <div className="rr-controls rr-controls-spaced">
//                                 <div className="rr-left">
//                                     Show
//                                     <select className="rr-select">
//                                         <option>10</option>
//                                         <option>25</option>
//                                         <option>50</option>
//                                     </select>
//                                     entries
//                                 </div>

//                                 <div className="rr-right">
//                                     <span>Search:</span>
//                                     <input className="rr-search" type="text" />
//                                 </div>
//                             </div>

//                             <CustomTable className="rr-table" striped={"false"}>
//                                 <tr>
//                                     <th>Word</th>
//                                     <th>Language</th>
//                                     <th>Action</th>
//                                     <th className="rr-action-col">Manage</th>
//                                 </tr>

//                                 {badwords.map((item) => (
//                                     <tr key={item.id}>
//                                         {/* <td>{item.word}</td> */}
//                                         <td>
//                                             {item.word.length > 2
//                                                 ? item.word.slice(0, 2) + "*".repeat(item.word.length - 2)
//                                                 : item.word}
//                                         </td>
//                                         <td>{languageLabel(item.language)}</td>
//                                         <td>{item.action === "block" ? "Block" : "Mask (****)"}</td>
//                                         <td className="rr-actions">
//                                             <CustomButton
//                                                 className="rr-icon-btn green"
//                                                 onClick={() => handleEdit(item)}
//                                             >
//                                                 <i className="bi bi-pencil"></i>
//                                             </CustomButton>
//                                             <CustomButton
//                                                 className="rr-icon-btn red"
//                                                 onClick={() => handleDeleteClick(item.id)}
//                                             >
//                                                 <i className="bi bi-trash"></i>
//                                             </CustomButton>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </CustomTable>

//                             <div className="rr-footer">
//                                 <span>
//                                     Showing 1 to {badwords.length} of {badwords.length} entries
//                                 </span>
//                                 <div className="rr-pagination">
//                                     <span className="rr-page-arrow">&lt;</span>
//                                     <span className="rr-page active">1</span>
//                                     <span className="rr-page-arrow">&gt;</span>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </SettingsPageShell>

//                 <Modal show={showModal} onHide={closeReasonModal} centered className="hashtag-add-modal">
//                     <Modal.Header className="hashtag-modal-header">
//                         <Modal.Title>{editId ? "Edit Bad Word" : "Add Bad Word"}</Modal.Title>
//                         <CustomButton type="button" className="hashtag-close-btn" onClick={closeReasonModal}>
//                             ×
//                         </CustomButton>
//                     </Modal.Header>

//                     <Modal.Body className="hashtag-modal-body">
//                         <Form.Group className="mb-3">
//                             <Form.Label className="profile-pill">Word</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={word}
//                                 placeholder="Enter word (any language)"
//                                 onChange={(e) => setWord(e.target.value)}
//                             />
//                         </Form.Group>

//                         <Form.Group className="mb-3">
//                             <Form.Label className="profile-pill">Language</Form.Label>
//                             <Form.Select value={language} onChange={(e) => setLanguage(e.target.value)}>
//                                 <option value="en">English</option>
//                                 <option value="ta">Tamil</option>
//                                 <option value="te">Telugu</option>
//                                 <option value="kn">Kannada</option>
//                                 <option value="ml">Malayalam</option>
//                                 <option value="hi">Hindi</option>
//                             </Form.Select>
//                         </Form.Group>

//                         <Form.Group className="mb-3">
//                             <Form.Label className="profile-pill">Action</Form.Label>
//                             <Form.Select value={action} onChange={(e) => setAction(e.target.value)}>
//                                 <option value="block">Block (comment fully rejected)</option>
//                                 <option value="mask">Mask (shows as ****)</option>
//                             </Form.Select>
//                         </Form.Group>
//                     </Modal.Body>

//                     <Modal.Footer className="hashtag-modal-footer">
//                         <CustomButton className="hashtag-close-footer-btn" variant="secondary" onClick={closeReasonModal}>
//                             Cancel
//                         </CustomButton>
//                         <CustomButton variant="primary" className="hashtag-save-btn" onClick={handleSubmit}>
//                             {editId ? "Update" : "Submit"}
//                         </CustomButton>
//                     </Modal.Footer>
//                 </Modal>

//                 <DeleteModal
//                     show={showDeleteModal}
//                     close={() => {
//                         setShowDeleteModal(false);
//                         setDeleteId(null);
//                     }}
//                     onDelete={deleteBadword}
//                     title="Delete Bad Word"
//                     message="Are you sure you want to delete this word?"
//                 />
//             </Layout>
//         </>
//     );
// }

export default function BadWordsPage() {
    const [badwords, setBadwords] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [word, setWord] = useState("");
    const [language, setLanguage] = useState("en");
    const [action, setAction] = useState("block");

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    // ---- pagination + search state (new) ----
    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);

    const fetchBadwords = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${ApiUrl}api/getbadwords`);
            setBadwords(res.data.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBadwords();
    }, []);

   
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, entriesPerPage]);

    const handleAdd = () => {
        setEditId(null);
        setWord("");
        setLanguage("en");
        setAction("block");
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditId(item.id);
        setWord(item.word);
        setLanguage(item.language);
        setAction(item.action);
        setShowModal(true);
    };

    const closeReasonModal = () => {
        setShowModal(false);
        setEditId(null);
    };

    const handleSubmit = async () => {
        if (!word.trim()) return;
        try {
            if (editId) {
                await axios.put(`${ApiUrl}api/updatebadwords/${editId}`, { word, language, action });
            } else {
                await axios.post(`${ApiUrl}api/postbadwords`, { word, language, action });
            }
            closeReasonModal();
            fetchBadwords();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const deleteBadword = async () => {
        try {
            await axios.delete(`${ApiUrl}api/deletebadwords/${deleteId}`);
            setShowDeleteModal(false);
            setDeleteId(null);
            fetchBadwords();
        } catch (err) {
            console.error(err);
        }
    };

    const languageLabel = (code) => {
        const map = { en: "English", ta: "Tamil", te: "Telugu", kn: "Kannada", ml: "Malayalam", hi: "Hindi" };
        return map[code] || code;
    };

  
    const filteredWords = badwords.filter((item) =>
        item.word.toLowerCase().includes(searchTerm.toLowerCase()) ||
        languageLabel(item.language).toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.max(1, Math.ceil(filteredWords.length / entriesPerPage));
    const startIndex = (currentPage - 1) * entriesPerPage;
    const paginatedWords = filteredWords.slice(startIndex, startIndex + entriesPerPage);

    const goToPage = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    return (
        <>
            <Layout>
                <SettingsPageShell
                    title="BAD WORDS FILTER"
                    headerRight={
                        <button className="rr-add-btn" onClick={handleAdd}>
                            Add Bad Word
                        </button>
                    }
                >
                    {loading ? (
                        <div className="rr-card">
                            <p>Loading...</p>
                        </div>
                    ) : (
                        <div className="rr-card">
                            <div className="rr-controls rr-controls-spaced">
                                <div className="rr-left">
                                    Show
                                    <select
                                        className="rr-select"
                                        value={entriesPerPage}
                                        onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                    </select>
                                    entries
                                </div>

                                <div className="rr-right">
                                    <span>Search:</span>
                                    <input
                                        className="rr-search"
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            <CustomTable className="rr-table" striped={"false"}>
                                <tr>
                                    <th>Word</th>
                                    <th>Language</th>
                                    <th>Action</th>
                                    <th className="rr-action-col">Manage</th>
                                </tr>

                                {paginatedWords.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            {item.word.length > 2
                                                ? item.word.slice(0, 2) + "*".repeat(item.word.length - 2)
                                                : item.word}
                                        </td>
                                        <td>{languageLabel(item.language)}</td>
                                        <td>{item.action === "block" ? "Block" : "Mask (****)"}</td>
                                        <td className="rr-actions">
                                            <CustomButton
                                                className="rr-icon-btn green"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </CustomButton>
                                            <CustomButton
                                                className="rr-icon-btn red"
                                                onClick={() => handleDeleteClick(item.id)}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </CustomButton>
                                        </td>
                                    </tr>
                                ))}

                                {paginatedWords.length === 0 && (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center" }}>
                                            No matching words found
                                        </td>
                                    </tr>
                                )}
                            </CustomTable>

                            <div className="rr-footer">
                                <span>
                                    Showing {filteredWords.length === 0 ? 0 : startIndex + 1} to{" "}
                                    {Math.min(startIndex + entriesPerPage, filteredWords.length)} of{" "}
                                    {filteredWords.length} entries
                                </span>
                                <div className="rr-pagination">
                                    <span
                                        className="rr-page-arrow"
                                        onClick={() => goToPage(currentPage - 1)}
                                        style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.5 : 1 }}
                                    >
                                        &lt;
                                    </span>
                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                        <span
                                            key={page}
                                            className={`rr-page ${page === currentPage ? "active" : ""}`}
                                            onClick={() => goToPage(page)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {page}
                                        </span>
                                    ))}
                                    <span
                                        className="rr-page-arrow"
                                        onClick={() => goToPage(currentPage + 1)}
                                        style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer", opacity: currentPage === totalPages ? 0.5 : 1 }}
                                    >
                                        &gt;
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </SettingsPageShell>

                <Modal show={showModal} onHide={closeReasonModal} centered className="hashtag-add-modal">
                    <Modal.Header className="hashtag-modal-header">
                        <Modal.Title>{editId ? "Edit Bad Word" : "Add Bad Word"}</Modal.Title>
                        <CustomButton type="button" className="hashtag-close-btn" onClick={closeReasonModal}>
                            ×
                        </CustomButton>
                    </Modal.Header>

                    <Modal.Body className="hashtag-modal-body">
                        <Form.Group className="mb-3">
                            <Form.Label className="profile-pill">Word</Form.Label>
                            <Form.Control
                                type="text"
                                value={word}
                                placeholder="Enter word (any language)"
                                onChange={(e) => setWord(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="profile-pill">Language</Form.Label>
                            <Form.Select value={language} onChange={(e) => setLanguage(e.target.value)}>
                                <option value="en">English</option>
                                <option value="ta">Tamil</option>
                                <option value="te">Telugu</option>
                                <option value="kn">Kannada</option>
                                <option value="ml">Malayalam</option>
                                <option value="hi">Hindi</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="profile-pill">Action</Form.Label>
                            <Form.Select value={action} onChange={(e) => setAction(e.target.value)}>
                                <option value="block">Block (comment fully rejected)</option>
                                <option value="mask">Mask (shows as ****)</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer className="hashtag-modal-footer">
                        <CustomButton className="hashtag-close-footer-btn" variant="secondary" onClick={closeReasonModal}>
                            Cancel
                        </CustomButton>
                        <CustomButton variant="primary" className="hashtag-save-btn" onClick={handleSubmit}>
                            {editId ? "Update" : "Submit"}
                        </CustomButton>
                    </Modal.Footer>
                </Modal>

                <DeleteModal
                    show={showDeleteModal}
                    close={() => {
                        setShowDeleteModal(false);
                        setDeleteId(null);
                    }}
                    onDelete={deleteBadword}
                    title="Delete Bad Word"
                    message="Are you sure you want to delete this word?"
                />
            </Layout>
        </>
    );
}